import { tv } from 'tailwind-variants'

import { caption, h3, h4, overline } from '@ui-kit/core/typography'

export const avatar = tv({
  slots: {
    container: 'flex flex-col gap-y-1',
    circle: 'relative flex flex-col items-center justify-center rounded-full',
    initials: 'text-center',
    iconContainer:
      'absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center overflow-hidden rounded-full bg-white',
    textContainer: 'w-16',
    title: [caption({}), 'text-center'],
    subtitle: [overline({ emphasis: 'medium' }), 'text-center'],
  },
  variants: {
    interactive: {
      true: {
        container: 'active cursor-pointer hover:opacity-70 web:transition web:duration-300',
      },
    },
    size: {
      sm: {
        circle: 'h-12 w-12',
        initials: [h4({ type: 'primary' })],
        textContainer: 'w-12',
      },
      md: {
        circle: 'h-16 w-16',
        initials: [h3({ type: 'primary' })],
        textContainer: 'w-16',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
